var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWindowInfo01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "160px",
    height: "159.999px",
    viewBox: "32.823 75.49 160 159.999",
    enableBackground: "new 32.823 75.49 160 159.999",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2AC49E",
    d: "M112.823,75.49c-44.183,0-80,35.816-80,79.999s35.817,80,80,80c44.182,0,80-35.817,80-80 S157.004,75.49,112.823,75.49z M112.823,215.456c-33.119,0-59.967-26.848-59.967-59.967c0-33.118,26.848-59.966,59.967-59.966 c33.118,0,59.967,26.848,59.967,59.966C172.79,188.608,145.941,215.456,112.823,215.456z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#1CA94B",
    d: "M112.837,123.226c-5.024,0.007-8.929-3.835-8.982-8.837 c-0.054-5.055,4.146-9.261,9.134-9.148c4.892,0.111,8.834,4.198,8.8,9.121C121.754,119.366,117.861,123.22,112.837,123.226z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#1CA94B",
    d: "M127.057,189.638h-6.968v-46.164c0-4.089-3.315-7.404-7.404-7.404 H98.749c-4.089,0-7.403,3.315-7.403,7.404s3.314,7.403,7.403,7.403h6.533v38.761h-6.968c-4.089,0-7.403,3.314-7.403,7.403 s3.314,7.403,7.403,7.403h28.744c4.089,0,7.403-3.314,7.403-7.403S131.146,189.638,127.057,189.638z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowInfo01);
export default __webpack_public_path__ + "static/media/window_info-01.cd247d56e80d629002e75c4a7368aed3.svg";
export { ForwardRef as ReactComponent };